import { ElementRef, EventEmitter, Injectable } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';

export interface IPosition {
    left: number;
    top: number;
}
export interface ImageState{
    state: boolean;
    imageUrl?: string;
    position?: IPosition;
    size: number;
}

@Injectable()
export class ImgTipService {

    private stateEventEmitter: Subject<ImageState> = new Subject<ImageState>();     

    public onChange = (cancelToken: Subject<void>): Observable<ImageState> =>
        this.stateEventEmitter.asObservable().pipe(takeUntil(cancelToken));

    showTooltip = (nativeElement: Element, imgName: string, imgSize: number = 400) => {        
        const r = nativeElement.getBoundingClientRect();
        let left = r.left + r.width;
        if (left + imgSize > window.innerWidth)
            left -= (r.width + imgSize);
        let top = r.top - 200;
        this.stateEventEmitter.next({
            state: true,
            size: imgSize,
            imageUrl: `/assets/tips/${imgName}.png`,
            position: {
                left: left,
                top: top
            }
        });
    }

    hideTooltip = () => {
        this.stateEventEmitter.next({ state: false, size: 0 });
    }
}
